module.exports = __webpack_public_path__ + "img/icon-envio.eb9a9c24.svg";